module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner vertical-container"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    attrs: {
      "id": "buttons-right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.visible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.loginBtnText))]), _vm._v("  \n\n    "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "id": "dropdown-btn"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n        活動"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, _vm._l((_vm.dropdownItems), function(item) {
    return _c('span', [(item.disabled) ? _c('el-dropdown-item', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v(_vm._s(item.text) + " (敬請期待)")]) : _c('a', {
      staticClass: "dropdown-a",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('el-dropdown-item', [_vm._v(_vm._s(item.text))])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.visible,
      "title": _vm.dialogTitle,
      "modal-append-to-body": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('oauthlogin')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hackntu_logo"
  }, [_c('a', {
    attrs: {
      "href": "#/projects"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/hackntu-logo.png"),
      "alt": "hackntu_logo"
    }
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "github-star"
    }
  }, [_c('a', {
    staticClass: "github-button beside-logo",
    attrs: {
      "href": "https://github.com/hackntu/hackingmap",
      "data-icon": "octicon-star",
      "data-show-count": "true",
      "aria-label": "Star hackntu/hackingmap on GitHub"
    }
  }, [_vm._v("Star")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4840512"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner/Banner.vue
// module id = 983
// module chunks = 1